module.exports = __webpack_public_path__ + "static/media/bg-2.3b6f6283.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/web/bg-2.png
// module id = 50
// module chunks = 3